import Tick from '@/js/Tick'
const tick = new Tick()
tick.start()
export default tick
